(function () {
  "use strict";

  function initReveal() {
    var nodes = document.querySelectorAll(".reveal");
    if (!("IntersectionObserver" in window)) {
      nodes.forEach(function (n) { n.classList.add("is-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2, rootMargin: "0px 0px -40px 0px" });
    nodes.forEach(function (n) { io.observe(n); });
  }

  function initNavScroll() {
    var nav = document.querySelector(".site-nav");
    if (!nav) return;
    var onScroll = function () {
      if (window.scrollY > 24) nav.classList.add("is-scrolled");
      else nav.classList.remove("is-scrolled");
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  function initMobileMenu() {
    var btn = document.querySelector("[data-mobile-toggle]");
    var drawer = document.querySelector("[data-mobile-drawer]");
    var closeBtn = document.querySelector("[data-mobile-close]");
    if (!btn || !drawer) return;
    var open = function () {
      drawer.classList.remove("is-closed");
      drawer.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
    };
    var close = function () {
      drawer.classList.add("is-closed");
      drawer.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    };
    btn.addEventListener("click", open);
    if (closeBtn) closeBtn.addEventListener("click", close);
    drawer.querySelectorAll("a").forEach(function (a) { a.addEventListener("click", close); });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initReveal(); initNavScroll(); initMobileMenu(); });
  } else {
    initReveal(); initNavScroll(); initMobileMenu();
  }
})();
